import { Component, OnInit } from '@angular/core';
import {TokenPayload, UserService} from "../services/user.service";
import {  Router} from "@angular/router";
import {AssetsService} from "../services/assets.service";
import {NotificationsService} from "angular2-notifications";
import {Ng4LoadingSpinnerService} from "ng4-loading-spinner"
import {PuserserviceService} from "../services/puserservice.service";
import { SearchService} from "../services/transaction.service";
import {PagerserviceService} from "../services/pagerservice.service";
import {BankService} from "../services/bank.service";
import * as XLSX from 'xlsx';
import { AdminService } from '../services/admin.service';
import { APP_CONSTS } from '../consts/app.consts';
import { FiatDepositConfirmDialog } from '../fiatdepositconfirmdialog/fiatdepositconfirmdialog.component';
import { MatDialog } from '@angular/material';
@Component({
  selector: 'app-transactions',
  templateUrl: './transactions.component.html',
  styleUrls: ['./transactions.component.css']
})
export class FiatTransactionsComponent implements OnInit {

    tran: SearchService = {
        date: '',
        search: ''
    };


  /*store all transaction list variable*/

  transactions:Array<any>;
  deposits:Array<any>;
  depositslist: Array<any>;
  depositslist1: Array<any>;
  public settings:any

  search = '';

   /* Search variables */
    serach:string;
    FilPerpage:number;
    FilPage:number;
    actionSearch:string;
    filterAction:Boolean;
    filter:Boolean;
    /************************************/
    // pager Number
    pager: number;
    Tpager: number;
    searchObj = {
        time1: new Date(),
        time: new Date(),
        search : ''
    }

    /* Hide / show variables */
    TransactionActive:string;

    // array of all items to be paged
    private allItems1: any[];

    // pager object
    pager1: any = {};
    datePickerConfig: any = {};
    transactionlist = [];
    currentPage = 0;
    fileName:string;
  constructor(private userService:UserService,private router:Router,
              private assetService: AssetsService,
              private spinnerService: Ng4LoadingSpinnerService,
              private notifSer:NotificationsService,
              private pagerService:PagerserviceService,
              private pusherService:PuserserviceService,private bankService: BankService,
              private adminService:AdminService,
              private dialog: MatDialog) { }

  ngOnInit() {
      if (!this.userService.isLoggedIn()) {
          this.router.navigateByUrl('/index');
      }else {
          this.serach = '';
          this.actionSearch = 'Search';
          this.FilPerpage = 10;
          this.FilPage = 1;

          this.pager = 1;
          this.TransactionActive = null;
          this.filterAction = true;
          this.filter = false;
          this.geDepositsLists();
      }
  }



    TransactionDetails(i){
        this.TransactionActive = i;
    }

    TransactionDetailshide(){
        this.TransactionActive = null;
    }

    geDepositsListsexp() {
        this.bankService.getfiatdepositlists(this.FilPerpage, this.FilPage,this.searchObj,true).subscribe((success) => {
            this.spinnerService.hide();
            if (success.status) {
                this.deposits = success.deposit;
                this.depositslist1 = success.deposit;
                this.transactionlist = [];
                for(let i = 0; i<this.depositslist1.length; i++){
                    this.transactionlist.push({ 
                        'TxnID'             : this.depositslist1[i].txnid ? this.depositslist1[i].txnid :'',
                        'Timestamp'         : this.depositslist1[i].createdAt ? this.depositslist1[i].createdAt :'',
                        'User Legal Name'   : this.depositslist1[i].user_name ? this.depositslist1[i].user_name :'',
                        'Email'             : this.depositslist1[i].user_email ? this.depositslist1[i].user_email : '',
                        'Currency'          : this.depositslist1[i].currency ? this.depositslist1[i].currency : '',
                        'Amount'            : this.depositslist1[i].amount ? this.depositslist1[i].amount  : '',
                        'Fee'               : this.depositslist1[i].fee ? this.depositslist1[i].fee  : '',
                        'Transaction Fee'   : this.depositslist1[i].transaction_fee ? this.depositslist1[i].transaction_fee  : '',
                        'Bank Name'         : this.depositslist1[i].bank_name ? this.depositslist1[i].bank_name  : '',
                        'Reference id'      : this.depositslist1[i].otctxnid ? this.depositslist1[i].otctxnid  : '',
                        'Authorized By'     : this.depositslist1[i].admin_name ? this.depositslist1[i].admin_name  : '',
                        'Deposit Proof'     : this.depositslist1[i].deposit_proof ? this.depositslist1[i].deposit_proof  : '',
                        'Note'              : this.depositslist1[i].note ? this.depositslist1[i].note  : '',
                        'Status'            : this.depositslist1[i].status ? this.depositslist1[i].status  : ''
                    });
                          
                  }
            }
            this.fileName = 'Fiat Deposit Report.xlsx'
            const ws: XLSX.WorkSheet = XLSX.utils.json_to_sheet(this.transactionlist);

            /* generate workbook and add the worksheet */
            const wb: XLSX.WorkBook = XLSX.utils.book_new();
            XLSX.utils.book_append_sheet(wb, ws, 'Sheet1');

            /* save to file */
            XLSX.writeFile(wb, this.fileName);
        })
    }

    geDepositsLists() {
        this.bankService.getfiatdepositlists(this.FilPerpage, this.FilPage,this.searchObj,false).subscribe((success) => {
            this.spinnerService.hide();
            if (success.status) {
                this.deposits = success.deposit;
                this.depositslist = success.deposit;
                this.currentPage = success.current;
                this.Tpager = success.pages;
                this.setPage(this.FilPage);
            }
        }, (error) => {
            this.deposits = [];
            this.depositslist = []
            this.spinnerService.hide();
            this.notifSer.error(
                'Error',
                error.error.message,
                {
                    timeOut: 3000,
                    showProgressBar: true,
                    pauseOnHover: false,
                    clickToClose: true,
                    maxLength: 50
                }
            )
        })
    }


    SearchWithdraw(target) {
        this.spinnerService.show();
        this.searchObj.search = target.target.value;
        this.bankService.getfiatdepositlists(this.FilPerpage, this.FilPage,this.searchObj,'false').subscribe((success) => {
            if (success.status) {
                this.depositslist = success.deposit;
                this.Tpager = success.pages;
                this.setPage(this.FilPage);
            }
            this.spinnerService.hide();
        }, (error) => {
            this.spinnerService.hide();
            this.notifSer.error(
                'Error',
                error.error.message,
                {
                    timeOut: 3000,
                    showProgressBar: true,
                    pauseOnHover: false,
                    clickToClose: true,
                    maxLength: 50
                }
            )
        })
    }

    setPage(page: number) {
        // get pager object from service
        this.pager1 = this.pagerService.getPager(this.Tpager, page);
    }

    setPageOnClick(page: number) {
        this.pager = page;
        this.FilPage = this.pager;
        this.geDepositsLists();
    }
    /**
     * 
     * @param report export excel
     */
    exportExcel(report){
        this.fileName = 'TransactionReport.xlsx'
        const ws: XLSX.WorkSheet = XLSX.utils.json_to_sheet(this.transactionlist);
        
            /* generate workbook and add the worksheet */
            const wb: XLSX.WorkBook = XLSX.utils.book_new();
            XLSX.utils.book_append_sheet(wb, ws, 'Sheet1');
      
            /* save to file */
            XLSX.writeFile(wb, this.fileName);
    }
    /**
     * 
     * @param uid 
     * @param status 
     */
    updateDeposit(obj, status) {
        let finalStatus = (status) ? APP_CONSTS.DEPOSIT_TRANSACTION_STATUS.APPROVED : APP_CONSTS.TRANSACTION_STATUS.REJECTED;
        // if(obj && obj.is_clearjunction_txn==1){
        //     finalStatus=APP_CONSTS.DEPOSIT_TRANSACTION_STATUS.CLEAR_JUNCTION_PENDING;
        // }
        var sendobj = {
            userid: obj.userid,
            tnxid: obj.txnid,
            bankName: obj.bank_name,
            fee: obj.fee,
            note: obj.note,
            status: finalStatus,
            amount: obj.amount,
            currency: obj.currency,
            _id: obj._id
        }
        this.dialog.open(FiatDepositConfirmDialog, {
            data: sendobj,
            width: '480px',
        }).afterClosed().subscribe(result => {
            if (result && result.success) {
                // Refresh the table data or perform any necessary updates
                this.geDepositsLists();
            }
        });

    }
    showApproveRejectButton(trans){
        return trans.status==APP_CONSTS.DEPOSIT_TRANSACTION_STATUS.REQUEST
    }
}



// WEBPACK FOOTER //
// ./src/app/fiattransactions/transactions.component.ts